import React from 'react';

export const CheckboxBlankIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_1044_6432)">
            <rect width="24" height="24" rx="4" fill="white" />
            <rect x="1" y="1" width="22" height="22" rx="3" stroke="#BABABA" strokeWidth="2" />
        </g>
        <defs>
            <clipPath id="clip0_1044_6432">
                <rect width="24" height="24" rx="4" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
